import { useMemo } from "react";

import type { Contact, ContactSection } from "../types";

const unknownSectionKey = "#";

const sortSectionsByLetter = (sections: ContactSection): ContactSection => {
  const sortedSections = Object.keys(sections).sort((a: string, b: string) => {
    if (a === unknownSectionKey) {
      return 1;
    }

    if (b === unknownSectionKey) {
      return -1;
    }

    return a.localeCompare(b);
  });

  return sortedSections.reduce((acc, letter) => {
    acc[letter] = sections[letter];

    return acc;
  }, {} as ContactSection);
};

export const useContactSections = (contacts: Contact[]): ContactSection => {
  return useMemo(() => {
    const sections: ContactSection = {};

    for (const contact of contacts) {
      let displayName = "";

      if (contact.displayName) {
        displayName = contact.displayName.replace(/^[^A-Za-z]+/, "");
      }

      // Contact with no display name
      if (displayName.length === 0) {
        if (!sections[unknownSectionKey]) {
          sections[unknownSectionKey] = [];
        }

        sections[unknownSectionKey].push(contact);
        continue;
      }

      const firstLetter = displayName.charAt(0).toUpperCase();

      if (!sections[firstLetter]) {
        sections[firstLetter] = [];
      }

      sections[firstLetter].push(contact);
    }

    return sortSectionsByLetter(sections);
  }, [contacts]);
};
